
<template>
    <div>
        <div class="operate_item" style="font-weight: bold;border-bottom: 1px solid #ccc">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">{{$t('main.ScoreSetting')}}</span></el-col>
        </div>
        
        <div  class="scoreSetting">
            <div class="switch-box">
                <span>{{$t('main.ScoreSetting')}}</span>
                <el-switch 
                    v-model="activeQuestion.scoreOrNot" 
                    :active-value="1" 
                    :inactive-value="0"
                    @change="scoreOrNotChange"
                ></el-switch>
            </div>
        </div>
        <div 
            class="scoreSetting"
            v-if="(activeQuestion.questionsTypeId == 8 ||
            activeQuestion.questionsTypeId == 12) &&
            activeQuestion.scoreOrNot == 1"
        >
            <div class="option-score">
                <div
                    class="item-score"
                    v-for="(item, index) in activeQuestion.optionList"
                    :key="item.oid"
                >
                <p class="option-title">{{$t('main.option')}}{{index + 1}}</p>
                
                <PopoverNum
                    :value="item.optionScore"
                    :size="'mini'"
                    :min="-100"
                    :max="100"
                    :maxlength="4"
                    :content="$t('main.PleaseEnterAValueWithinMax100')"
                    @valueChange="(val) => item.optionScore = val"
                >
                </PopoverNum>
                </div>
            </div>
        </div>
        <div 
            class="scoreSetting"
            v-if="(activeQuestion.questionsTypeId == 38 ||
            activeQuestion.questionsTypeId == 11) &&
            activeQuestion.scoreOrNot == 1"
        >
            <p class="tips">{{$t('main.ScoreConversionRatioOfThisQuestion')}}</p>
            <PopoverNum
                :value="activeQuestion.percentageNum"
                :size="'mini'"
                :min="1"
                :max="10"
                :maxlength="2"
                :content="$t('main.PleaseEnterAValueWithinMax10')"
                @valueChange="(val) => activeQuestion.percentageNum = val"
            >
            </PopoverNum>
        </div>
        
        <div class="scoreSetting" 
            v-if="(activeQuestion.questionsTypeId == 8 ||
            activeQuestion.questionsTypeId == 12) &&
            activeQuestion.scoreOrNot == 1"
        >
            <div class="switch-box">
                <span>{{$t('main.ClosedLoopOrNot')}}</span>
                <el-switch 
                    v-model="activeQuestion.isClosedLoop" 
                    :active-value="true" 
                    :inactive-value="false"
                ></el-switch>
            </div>
        </div>
    </div>
</template>

<script>
import PopoverNum from "@/components/myComponents/popoverNum.vue"
export default {
    name: 'ScoreOrNotSet', // 量表题属性设置
    components:{
        PopoverNum
    },
    props: {
        activeQuestion: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return{
        }
    },
    created() {
    },
    methods: {
        scoreOrNotChange(e) {
            let { optionList } = this.activeQuestion
            if (e == 1) {
                optionList = optionList.map(item =>{
                    this.$set(item, 'optionScore', 5)
                })
            } else {
                optionList = optionList.map(item =>{
                    item.optionScore = 0
                })
            }
        }
    }
} 
</script>

<style scoped lang="scss">
.scoreSetting{        
    width: 90%;
    margin: 0px auto;
    font-size: 14px;
    .switch-box{
        min-height: 49px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .option-score{
        display: flex;
        flex-wrap: wrap;
        .option-title{
            margin-bottom: 10px;
        }
        .item-score {
            width: 50%;
            padding: 10px 4px;
            box-sizing: border-box;
        }
    }
    .tips{
        margin-bottom: 10px;
    }
}
</style>